import stream from 'mithril/stream'

const state = () => ({
  viewport: stream()
})

export default state
